var path = 'rulechain/rulechain-card.tpl.html';
var html = "\n<div ng-if=\"item && item.root\" translate>rulechain.root</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/rulechain/rulechain-card.tpl.html
// module id = 1512
// module chunks = 1